import React from 'react';
import { AddressDetails } from 'components/AddressDetails';
import { useSteps } from 'context/StepsProvider';
import { FormProvider } from 'react-hook-form';

const Embed = () => {
  const { formMethods } = useSteps();
  return (
    <FormProvider {...formMethods}>
      <AddressDetails />
    </FormProvider>
  );
};

export default Embed;
